import { useTranslation } from 'react-i18next';

import { Button, Drawer } from '@/components';

import { CompanySchema } from '../../types';
import { ProfileHeaderForm, ProfileHeaderFormFields } from './profile-header-form';

export type ProfileHeaderDrawerProps = {
  readonly formId: string;
  readonly company: CompanySchema;
  readonly isOpen: boolean;
  readonly isLoading?: boolean;
  readonly onSubmit: (data: ProfileHeaderFormFields) => void;
  readonly onClose: () => void;
};

export function ProfileHeaderDrawer({
  formId,
  company,
  isOpen,
  isLoading,
  onSubmit,
  onClose,
}: ProfileHeaderDrawerProps) {
  const { t } = useTranslation(['settings']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary" disabled={isLoading}>
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Identity')} open={isOpen} onClose={onClose} footer={footer}>
      <ProfileHeaderForm id={formId} company={company} onSubmit={onSubmit} />
    </Drawer>
  );
}
